import React, { useState, useEffect } from 'react'
import { superAxiosRequest } from 'axiosApi'
import {
  timeConverter,
  timeConverter2,
} from 'components/ContentBox/Online-schedule/components/functions'
import Stores from 'Stores'
import asideModalStore from 'Stores/asideModalStore'
import st from './EmployeeSkill.module.scss'
import { ReactComponent as IconEdit } from 'components/Modules/User/Employee/img/edit-line.svg'
import { ReactComponent as IconArrow } from 'components/Modules/User/Employee/img/arrow-down-s-line.svg'

export default function EmployeeSkillSoft(props) {
  const [contractList, setContractList] = useState([false, []])
  const [open, setOpen] = useState(false)

  let contract = {
    name: 'employee_contract',
    link: 'employees/contract',
    button: props.translate.add,
    title: props.translate.adding_contract,
    type: 'employee_contract',
    data: 'json',
    isResponsive: true,
    profile: props.items && props.items.profile.id,
  }
  const initStateContract = {
    date_from: timeConverter2(new Date()),
    date_until: timeConverter2(new Date().getFullYear() + '-12-31'),
    //salary_type: 1,
    //vacation_days: 10,
    //vacation_mins: 8,
    //test_plan_mins: 40,
    employee_id: props.items.profile.id,
    //hour_type: 60,
    //title: ''
  }

  const getContract = (array) => {
    let tmp = array[array.length - 1]
    return `${props.translate.valid_from} ${timeConverter(tmp.date_from, 'age')} ${props.translate.to} ${timeConverter(tmp.date_until, 'age')}` //asda
  }

  const updCont = () => {
    let contract_p = {
      name: 'employee_contract',
      link:
        'employees/contract/' + contractList[1][contractList[1].length - 1].id,
      button: props.translate.save,
      title: props.translate.edit_contract,
      type: 'employee_contract',
      data: 'json',
      is_put: true,
      isResponsive: true,
      profile: props.items && props.items.profile.id,
    }
    asideModalStore.activity(
      contract_p,
      contractList[1][contractList[1].length - 1],
    )
  }

  const onClickHandler = () => {
    if (
      contractList[1].length > 0 &&
      Stores.Rules.checkRule('contracts', 'edit')
    ) {
      updCont()
    } else if (Stores.Rules.checkRule('contracts', 'edit')) {
      asideModalStore.activity(contract, initStateContract)
    }
  }

  useEffect(() => {
    if (props.items !== undefined) {
      let apiConf = {
        method: 'get',
        link: 'employees/contract',
        params: {
          employee: props.items && props.items.profile.id,
        },
      }
      superAxiosRequest(apiConf).then((res) =>
        setContractList([true, res.data.result]),
      )
    }
  }, [props.items])

  return (
    <div className={st.employeeSkill}>
      <div className={st.title}>{props.translate.contract_duration}:</div>
      {open ? (
        <div className={st.info}>
          {contractList[0] && contractList[1].length > 0 ? (
            getContract(contractList[1])
          ) : (
            <div>{props.translate.no_current_contract}</div>
          )}
        </div>
      ) : (
        <div />
      )}
      <div className={st.buttons}>
        {open &&
          (Stores.Rules.checkRule('contracts', 'edit') ||
            Stores.Rules.checkRule('contracts', 'add')) && (
            <div className={`${st.btn} ${st.btnEdit}`} onClick={onClickHandler}>
              <IconEdit />
            </div>
          )}
        <div
          className={`${st.btn} ${open ? st.btnClose : st.btnOpen}`}
          onClick={() => setOpen(!open)}
        >
          <IconArrow />
        </div>
      </div>
    </div>
  )
}
